import {
  XOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  FacebookOutlined,
} from "@ant-design/icons";
import React from "react";
import "../assets/scss/components/_footer.scss";
import { Col, Container, Row } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row className="pb-3 px-2">
            <Col sm={6}>
              <div className="text-sm-start d-none d-sm-block ">
                2025 © DARU’L HUFFAZ <br /> Konya Büyükşehir Belediyesi -{" "}
                <a href="https://sehirteknolojileri.com/" target="_blank">
                  Şehir Teknolojileri Merkezi
                </a>
              </div>
            </Col>
            <Col
              sm={6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: "5px",
              }}
            >
              <a
                href="https://www.facebook.com/konyameslekedindirme"
                target="_blank"
              >
                <FacebookOutlined className="footer_social_media_icon" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCK6CQcfyK3kuPnKTQWe8g1A"
                target="_blank"
                className="footer_social_media_icon"
              >
                <YoutubeOutlined />
              </a>
              <a href="https://instagram.com/komekkonya" target="_blank">
                <InstagramOutlined className="footer_social_media_icon" />
              </a>
              <a href="https://x.com/komekkonya" target="_blank">
                <XOutlined className="footer_social_media_icon" />
              </a>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;

const IconStyle = {};
